import React, { useEffect, useState } from 'react';
import { Info } from 'lucide-react';
import api from '../../api/client';
import TessereList from '../../components/TessereList';
import { etichettaCondizione } from '../../utils/inquadramento';
import { nomeModalita, haFisso } from '../../utils/compenso';

const campo = (label, valore) => (
  <div>
    <div style={s.label}>{label}</div>
    <div style={s.valore}>{valore || valore === 0 ? valore : '—'}</div>
  </div>
);

export default function AnagraficaAllenatore() {
  const [d, setD]           = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/dipendenti/me/anagrafica')
      .then(r => setD(r.data))
      .catch(() => setD(null))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ padding:'40px', color:'#555' }}>Caricamento...</div>;
  if (!d) return <div style={{ padding:'40px', color:'#EF4444' }}>Dati non trovati.</div>;

  return (
    <div>
      <div style={{ marginBottom:'20px' }}>
        <h1 style={s.title}>I miei dati</h1>
        <p style={s.sub}>Sola lettura — per segnalare una modifica (es. cambio di residenza) contatta lo staff.</p>
      </div>

      <div style={{ background:'#F4600C10', border:'1px solid #F4600C30', borderRadius:'10px', padding:'12px 16px', marginBottom:'20px', display:'flex', alignItems:'flex-start', gap:'10px', fontSize: 'var(--font-size-xs)', color:'var(--text)' }}>
        <Info size={15} color="#F4600C" style={{ flexShrink:0, marginTop:'1px' }}/>
        Questi dati sono gestiti dallo staff. Se qualcosa non è più corretto (indirizzo, IBAN, situazione lavorativa, ecc.), segnalalo direttamente allo staff per la correzione: alcuni cambiano le trattenute sul tuo compenso.
      </div>

      <div style={s.sezLabel}>DATI GENERALI</div>
      <div style={s.grid}>
        {campo('NOME', d.nome)}
        {campo('COGNOME', d.cognome)}
        {campo('EMAIL', d.email)}
        {campo('TELEFONO', d.telefono)}
        {campo('MANSIONE', [d.ruolo_descrizione, d.ruolo_specifica && `(${d.ruolo_specifica})`].filter(Boolean).join(' '))}
        {campo('DATA INIZIO', d.data_inizio ? new Date(d.data_inizio).toLocaleDateString('it-IT') : null)}
        {campo('MODALITÀ COMPENSO', nomeModalita(d.modalita_compenso))}
        {haFisso(d.modalita_compenso) && campo('COMPENSO FISSO MENSILE', d.compenso_fisso != null ? `€${Number(d.compenso_fisso).toFixed(2)}` : null)}
        {d.modalita_compenso !== 'FISSO' && campo('TARIFFA ORARIA', d.tariffa_oraria != null ? `€${Number(d.tariffa_oraria).toFixed(2)}/h` : null)}
      </div>

      <div style={s.sezLabel}>DATI DI PAGAMENTO</div>
      <div style={s.grid}>
        {campo('IBAN', d.iban ? d.iban.replace(/(.{4})/g, '$1 ').trim() : null)}
        {campo('BANCA', d.banca)}
      </div>

      <div style={s.sezLabel}>DATI ANAGRAFICI</div>
      <div style={s.grid}>
        {campo('CODICE FISCALE', d.codice_fiscale)}
        {campo('DATA DI NASCITA', d.data_nascita ? new Date(d.data_nascita).toLocaleDateString('it-IT') : null)}
        {campo('LUOGO DI NASCITA', d.luogo_nascita)}
        {campo('PROVINCIA DI NASCITA', d.provincia_nascita)}
      </div>

      <div style={s.sezLabel}>RESIDENZA</div>
      <div style={s.grid}>
        <div style={{ gridColumn:'1/-1' }}>{campo('INDIRIZZO', d.indirizzo_residenza)}</div>
        {campo('CAP', d.cap)}
        {campo('PROVINCIA', d.provincia)}
        <div style={{ gridColumn:'1/-1' }}>{campo('PAESE', d.paese)}</div>
      </div>

      <div style={s.sezLabel}>INQUADRAMENTO PREVIDENZIALE E FISCALE</div>
      <p style={s.nota}>
        Servono a chi elabora i compensi per applicare contributi e tasse corretti.
        {d.inquadramento_aggiornato_al && <> Ultimo aggiornamento: <b>{new Date(d.inquadramento_aggiornato_al).toLocaleDateString('it-IT')}</b>.</>}
      </p>
      <div style={s.grid}>
        {campo('SITUAZIONE LAVORATIVA', etichettaCondizione(d.condizione_professionale))}
        {campo('GIÀ COPERTO DA ALTRA PREVIDENZA / PENSIONATO', d.altra_previdenza === true ? 'Sì' : d.altra_previdenza === false ? 'No' : 'Da verificare')}
        <div style={{ gridColumn:'1/-1' }}>{campo('DETRAZIONI DA LAVORO (OLTRE €15.000)', d.richiede_detrazioni ? 'Richieste' : 'Non richieste')}</div>
        <div style={{ gridColumn:'1/-1' }}>{campo('NOTE FISCALI (familiari a carico, altri redditi, ...)', d.note_fiscali)}</div>
      </div>

      <div style={s.sezLabel}>COMPENSI B-CHEERS PERIODO GENNAIO–AGOSTO</div>
      <p style={s.nota}>Quanto ti abbiamo già pagato nell'anno prima dell'uso del gestionale: conta per le soglie fiscali insieme ai compensi successivi.</p>
      <div style={s.grid}>
        {campo('IMPORTO', d.compenso_pregresso_importo ? `€${Number(d.compenso_pregresso_importo).toFixed(2)}` : null)}
        {campo('ANNO', d.compenso_pregresso_anno)}
      </div>

      <div style={s.sezLabel}>COMPENSI GIÀ PERCEPITI DA ALTRE SOCIETÀ SPORTIVE</div>
      <p style={s.nota}>Le soglie fiscali dei compensi sportivi valgono sommando tutte le società nell'anno: se hai incassato altrove e qui non risulta, segnalalo.</p>
      <div style={s.grid}>
        {campo('IMPORTO', d.compenso_extra_importo ? `€${Number(d.compenso_extra_importo).toFixed(2)}` : null)}
        {campo('ANNO', d.compenso_extra_anno)}
      </div>

      <div style={s.sezLabel}>DICHIARAZIONI PER IL CONTRATTO</div>
      <div style={s.grid}>
        <div style={{ gridColumn:'1/-1' }}>{campo('DIPENDENTE DI UNA PUBBLICA AMMINISTRAZIONE', d.dipendente_pubblico ? 'Sì' : 'No')}</div>
      </div>

      <div style={s.sezLabel}>TESSERAMENTO</div>
      <TessereList/>
    </div>
  );
}

const s = {
  title:    { fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-title)', fontWeight:'800', letterSpacing:'2px' },
  sub:      { color:'var(--text-muted,#888)', fontSize: 'var(--font-size-sm)', marginTop:'2px' },
  sezLabel: { fontSize: 'var(--font-size-xs)', fontWeight:'700', letterSpacing:'2px', color:'#555', marginBottom:'10px', marginTop:'4px' },
  grid:     { display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(220px, 1fr))', gap:'12px', marginBottom:'20px' },
  nota:     { fontSize: 'var(--font-size-xs)', color:'#888', margin:'-4px 0 12px' },
  label:    { fontSize: 'var(--font-size-xs)', letterSpacing:'2px', fontWeight:'700', color:'#555', marginBottom:'4px' },
  valore:   { whiteSpace:'pre-wrap', overflowWrap:'anywhere', background:'var(--bg-input,#1A1A1A)', border:'1px solid var(--border2,#2A2A2A)', borderRadius:'8px', padding:'9px 12px', color:'var(--text,#fff)', fontSize: 'var(--font-size-sm)' },
};
